import {Service} from '@s-ui/domain'

import GetCurrentUserService from '../../user/Services/GetCurrentUserService.js'
import NotificationsRepositoriesFactory from '../Repositories/factory.js'
import {UnreadMessagesValueObject} from '../ValueObjects/UnreadMessagesValueObject.js'

export class GetUnreadMessagesService extends Service {
  #config
  #getCurrentUserService
  #repository
  #unreadMessagesValueObject
  #defaultUnreadMessages

  constructor({config, getCurrentUserService, repository, unreadMessagesValueObject}) {
    super()

    this.#config = config
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
    this.#unreadMessagesValueObject = unreadMessagesValueObject

    this.#defaultUnreadMessages = this.#config.get('notifications').DEFAULT_UNREAD_MESSAGES
  }

  static create({config}) {
    return new GetUnreadMessagesService({
      config,
      getCurrentUserService: GetCurrentUserService.create({config}),
      repository:
        typeof localStorage !== 'undefined'
          ? NotificationsRepositoriesFactory.httpNotificationsRepository({
              config
            })
          : NotificationsRepositoriesFactory.emptyNotificationsRepository({
              config
            }),
      unreadMessagesValueObject: UnreadMessagesValueObject.create
    })
  }

  execute = async () => {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity)
      return this.#unreadMessagesValueObject({
        unreadMessages: this.#defaultUnreadMessages
      })

    const [error, unreadMessagesVO] = await this.#repository().getUnreadMessages({userEntity})

    if (error)
      return this.#unreadMessagesValueObject({
        unreadMessages: this.#defaultUnreadMessages
      })

    return unreadMessagesVO
  }
}
